import GetCustomersData from "../Comman/GetCustomersData";
import GetItemData from "../Comman/GetItemData";
import GetSoldItemsData from "../Comman/GetSoldItesmData";
import GetAuthUserDataInFirebase from "./AgencyMember/GetAgencyMemberDataInFirebase";
import GetBusinessDataFirebase from "./Business/GetBusinessDataFirebase";
import GetExpenseDataFirebase from "./Expense/GetExpenseDataFirebase";
import GetInvoiceDataFirebase from "./Invoice/GetInvoiceDataFirebase";
import GetPaymentData from "./Payment/GetPaymentData";
import GetProformaInvoiceDataFirebase from "./ProformaInvoice/GetProformaInvoiceDataFirebase";
import GetQuotationDataFirebase from "./Quotation/GetQuotationDataFirebase";
import GetSaleReturnDataFirebase from "./SaleReturn/GetSaleReturnDataFirebase";
import GetSessionData from "./Session/GetSessionData";
import GetRefereeUserDataInFirebase from "./User/GetReferreUserDataInFirebase";
import GetAssignerUserDataInfirebase from "./AssignerUser/GetAssignerUserDataInfirebase";


const FetchAllDataFromFirebase = async (state, dispatch) => {


    if (!state?.USERID || state?.USERID == null || state?.USERID == undefined) return null;

    try {
        const fetchedAssigners = await GetAssignerUserDataInfirebase(state, dispatch, state.USERID);
        const companyResult = await GetBusinessDataFirebase(state, dispatch, fetchedAssigners);
        const companyData = companyResult?.ownBusinesses || null;
        const sharedBusinesses = companyResult?.sharedBusinesses || null;

        const allCustomers = await GetCustomersData(state, dispatch, sharedBusinesses);
        const invoiceData = await GetInvoiceDataFirebase(state, dispatch, sharedBusinesses, allCustomers);
        const SessionData = await GetSessionData(state, dispatch);
        const PaymentData = await GetPaymentData(state, dispatch);
        const expenseData = await GetExpenseDataFirebase(state, dispatch, sharedBusinesses);
        const saleReturnData = await GetSaleReturnDataFirebase(state, dispatch, sharedBusinesses);
        const ProformaInvoiceData = await GetProformaInvoiceDataFirebase(state, dispatch, sharedBusinesses, allCustomers);
        const QuotationData = await GetQuotationDataFirebase(state, dispatch, sharedBusinesses, allCustomers);
        const authUserData = await GetAuthUserDataInFirebase(state, dispatch);
        const refereeUserData = await GetRefereeUserDataInFirebase(state, dispatch, state?.SET_USER?.referral_code)
        // Combined Sold Items calculation
        const allTransactions = [
            ...(invoiceData || []),
            ...(QuotationData || []),
            ...(ProformaInvoiceData || []),
        ];
        // Final item fetch including shared items
        const combinedItemData = await GetItemData(state, dispatch, null, sharedBusinesses, allTransactions);

        // Fetch Sold Items ONLY from Invoices as per user request
        await GetSoldItemsData(state, dispatch, invoiceData || [], combinedItemData);

        return { companyData, invoiceData, SessionData, PaymentData, expenseData, saleReturnData, ProformaInvoiceData, QuotationData, authUserData, refereeUserData };

    } catch (error) {
        console.error("Error fetching all data:", error);
        return null;
    }
};

export default FetchAllDataFromFirebase;
